
(function () {

  function toNumber(val) {
    const v = (val || "").trim().replace(/\s+/g, "").replace(",", ".");
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : null;
  }

  function getCellValue(row, colIndex) {
    return (row.children[colIndex]?.textContent || "").trim();
  }

  function clearSortState(headers) {
    headers.forEach((h) => {
      h.classList.remove("is-sorted-asc", "is-sorted-desc");
      delete h.dataset.sortDir;
    });
  }

  function setHeaderState(headers, activeTh, dir) {
    clearSortState(headers);
    activeTh.dataset.sortDir = dir;
    activeTh.classList.add(dir === "asc" ? "is-sorted-asc" : "is-sorted-desc");
  }

  function sortTableByTh(th, forceAsc = false) {
    const table = th.closest(".spa-table");
    if (!table) return;

    const tbody = table.querySelector("tbody");
    if (!tbody) return;

    const headers = Array.from(th.parentNode.children);
    const colIndex = headers.indexOf(th);

    const currentlySorted = th.dataset.sortDir; // "asc" | "desc" | undefined

    let nextDir = "asc";
    if (forceAsc) {
      nextDir = "asc";
    } else if (currentlySorted) {
      nextDir = currentlySorted === "asc" ? "desc" : "asc";
    } else {
      nextDir = "asc";
    }

    const sortType = th.dataset.sortType || "text";
    const rows = Array.from(tbody.querySelectorAll("tr"));

    rows.sort((a, b) => {
      const aVal = getCellValue(a, colIndex);
      const bVal = getCellValue(b, colIndex);

      if (sortType === "number") {
        const aNum = toNumber(aVal);
        const bNum = toNumber(bVal);

        if (aNum === null && bNum === null) return 0;
        if (aNum === null) return 1;
        if (bNum === null) return -1;

        return nextDir === "asc" ? aNum - bNum : bNum - aNum;
      }

      const cmp = aVal.localeCompare(bVal, "fr", { sensitivity: "base" });
      return nextDir === "asc" ? cmp : -cmp;
    });

    tbody.innerHTML = "";
    rows.forEach((r) => tbody.appendChild(r)); 

    setHeaderState(headers, th, nextDir);
  }

  function applyDefaultSort(root) {
    root.querySelectorAll(".spa-table").forEach((table) => {
      const firstTh = table.querySelector("thead th");
      if (!firstTh) return;

      // On force l'asc pour la première colonne (Modèle)
      sortTableByTh(firstTh, true);
    });
  }

  function bindEventsOnce() {
    if (document.documentElement.dataset.spaDimensionsBound === "1") return;
    document.documentElement.dataset.spaDimensionsBound = "1";

    // Recherche live
    document.addEventListener("input", function (e) {
      const input = e.target.closest(".spa-search");
      if (!input) return;

      const brandID = input.dataset.brand;
      const table = document.querySelector(`.spa-table[data-brand="${brandID}"]`);
      if (!table) return;

      const rows = table.querySelectorAll("tbody tr");
      const query = (input.value || "").toLowerCase();

      rows.forEach((row) => {
        const text = row.textContent.toLowerCase();
        row.style.display = text.includes(query) ? "" : "none";
      });
    });

    // Tri
    document.addEventListener("click", function (e) {
      const th = e.target.closest(".spa-table th");
      if (!th) return;

      const table = th.closest(".spa-table");
      if (!table) return;

      const headers = Array.from(th.parentNode.children);

      // Si une autre colonne était triée, celle-ci démarre en asc
      const anotherSorted = headers.some((h) => h !== th && h.dataset.sortDir);
      const forceAsc = !th.dataset.sortDir && anotherSorted;

      sortTableByTh(th, forceAsc);
    });
  }

  function init(root) {
    bindEventsOnce();
    applyDefaultSort(root || document);
  }

  // Chargement normal
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Shopify theme editor (rechargement de section)
  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });

})();
